import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
  Typography,
} from "@mui/material";
import HeaderLabelGridField from "../../../unit/HeaderLabelGridField";
import HeaderLabelTitle from "../../../unit/HeaderLabelTitle";
import LabelField from "../../../unit/LabelField";
import ShowFieldFromListByKey from "../../../unit/ShowFieldFromListByKey";
const CreditScore = ({ sourcedata }: any) => {
  if (!sourcedata || !sourcedata.scoreModel) {
    return <>NA</>;
  }
  const scoreModel = sourcedata.scoreModel;
  const score = scoreModel?.score;
  const factors = score?.factors?.factor;

  return (
    <Accordion>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1-content"
        id="panel1-header"
      >
        <HeaderLabelTitle title="Credit Score" suffix="" />
      </AccordionSummary>
      <AccordionDetails>
        <Grid container rowSpacing={1} columnSpacing={1}>
          <HeaderLabelGridField
            title="Status"
            value={scoreModel.searchStatus}
            dxs={10}
            tdxs={2}
          />
          <HeaderLabelGridField
            title="Score"
            value={score && score.results ? score.results : ""}
            dxs={10}
            tdxs={2}
            fontFamily="numberFontFamily"
          />
        </Grid>
        {Array.isArray(factors) && factors.length > 0 ? (
          <>
            {factors.map((item: any, index: any) => (
              <Typography key={index} variant="body2" color="textSecondary">
                {item.rank} :
                {ShowFieldFromListByKey(item.code, sourcedata.factorCodeData)}
              </Typography>
            ))}
          </>
        ) : (
          <LabelField value="No Data" />
        )}
        <Grid container rowSpacing={1} columnSpacing={1}>
          <HeaderLabelGridField
            title="Score Card Used"
            value={score && score.scoreCard ? score.scoreCard : ""}
            dxs={10}
            tdxs={2}
            fontFamily="numberFontFamily"
          />
          <HeaderLabelGridField
            title="No Score Reason"
            value={score && score.noScoreReason ? score.noScoreReason : ""}
            dxs={10}
            tdxs={2}
          />
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};

export default CreditScore;
